module.exports = function InvalidMonthsAbbrError(message) {
  this.message = message;
  this.name = 'InvalidWeekdaysAbbrError';
};
